import { useState } from "react";
import "./App.css";

const AW = {
  H:1.008,He:4.003,Li:6.941,Be:9.012,B:10.811,C:12.011,N:14.007,O:15.999,
  F:18.998,Ne:20.180,Na:22.990,Mg:24.305,Al:26.982,Si:28.086,P:30.974,S:32.065,
  Cl:35.453,Ar:39.948,K:39.098,Ca:40.078,Sc:44.956,Ti:47.867,V:50.942,Cr:51.996,
  Mn:54.938,Fe:55.845,Co:58.933,Ni:58.693,Cu:63.546,Zn:65.38,Ga:69.723,Ge:72.640,
  As:74.922,Se:78.960,Br:79.904,Kr:83.798,Rb:85.468,Sr:87.620,Y:88.906,Zr:91.224,
  Nb:92.906,Mo:95.960,Ru:101.07,Rh:102.906,Pd:106.42,Ag:107.868,Cd:112.411,
  In:114.818,Sn:118.710,Sb:121.760,Te:127.60,I:126.904,Xe:131.293,Cs:132.905,
  Ba:137.327,La:138.905,Ce:140.116,Pr:140.908,Nd:144.242,Sm:150.36,Eu:151.964,
  Gd:157.25,Tb:158.925,Dy:162.500,Ho:164.930,Er:167.259,Tm:168.934,Yb:173.054,
  Lu:174.967,Hf:178.49,Ta:180.948,W:183.84,Re:186.207,Os:190.23,Ir:192.217,
  Pt:195.084,Au:196.967,Hg:200.59,Tl:204.383,Pb:207.2,Bi:208.980,Th:232.038,U:238.029
};

const COMPOUNDS = {
  // Water
  water:{formula:"H2O",name:"Water"},
  h2o:{formula:"H2O",name:"Water"},

  // Sugars
  glucose:{formula:"C6H12O6",name:"Glucose"},
  fructose:{formula:"C6H12O6",name:"Fructose"},
  sucrose:{formula:"C12H22O11",name:"Sucrose"},
  lactose:{formula:"C12H22O11",name:"Lactose"},
  maltose:{formula:"C12H22O11",name:"Maltose"},
  ribose:{formula:"C5H10O5",name:"Ribose"},
  deoxyribose:{formula:"C5H10O4",name:"Deoxyribose"},

  // Alcohols & Solvents
  ethanol:{formula:"C2H6O",name:"Ethanol"},
  methanol:{formula:"CH4O",name:"Methanol"},
  acetone:{formula:"C3H6O",name:"Acetone"},
  glycerol:{formula:"C3H8O3",name:"Glycerol"},
  isopropanol:{formula:"C3H8O",name:"Isopropanol"},
  "isopropyl alcohol":{formula:"C3H8O",name:"Isopropyl alcohol"},
  ethylene:{formula:"C2H4",name:"Ethylene"},
  "ethylene glycol":{formula:"C2H6O2",name:"Ethylene glycol"},

  // Hydrocarbons
  benzene:{formula:"C6H6",name:"Benzene"},
  toluene:{formula:"C7H8",name:"Toluene"},
  methane:{formula:"CH4",name:"Methane"},
  ethane:{formula:"C2H6",name:"Ethane"},
  propane:{formula:"C3H8",name:"Propane"},
  butane:{formula:"C4H10",name:"Butane"},
  hexane:{formula:"C6H14",name:"Hexane"},
  naphthalene:{formula:"C10H8",name:"Naphthalene"},

  // Common Drugs / Pharmaceuticals
  aspirin:{formula:"C9H8O4",name:"Aspirin"},
  ibuprofen:{formula:"C13H18O2",name:"Ibuprofen"},
  paracetamol:{formula:"C8H9NO2",name:"Paracetamol"},
  acetaminophen:{formula:"C8H9NO2",name:"Acetaminophen"},
  caffeine:{formula:"C8H10N4O2",name:"Caffeine"},
  penicillin:{formula:"C16H18N2O4S",name:"Penicillin G"},
  amoxicillin:{formula:"C16H19N3O5S",name:"Amoxicillin"},
  metformin:{formula:"C4H11N5",name:"Metformin"},
  omeprazole:{formula:"C17H19N3O3S",name:"Omeprazole"},
  atorvastatin:{formula:"C33H35FN2O5",name:"Atorvastatin"},
  warfarin:{formula:"C19H16O4",name:"Warfarin"},
  diazepam:{formula:"C16H13ClN2O",name:"Diazepam"},
  morphine:{formula:"C17H19NO3",name:"Morphine"},
  codeine:{formula:"C18H21NO3",name:"Codeine"},
  naproxen:{formula:"C14H14O3",name:"Naproxen"},
  cetirizine:{formula:"C21H25ClN2O3",name:"Cetirizine"},
  salbutamol:{formula:"C13H21NO3",name:"Salbutamol"},
  albuterol:{formula:"C13H21NO3",name:"Albuterol"},
  sildenafil:{formula:"C22H30N6O4S",name:"Sildenafil"},
  lisinopril:{formula:"C21H31N3O5",name:"Lisinopril"},
  simvastatin:{formula:"C25H38O5",name:"Simvastatin"},
  tamoxifen:{formula:"C26H29NO",name:"Tamoxifen"},
  ciprofloxacin:{formula:"C17H18FN3O3",name:"Ciprofloxacin"},
  azithromycin:{formula:"C38H72N2O12",name:"Azithromycin"},
  doxycycline:{formula:"C22H24N2O8",name:"Doxycycline"},
  chloroquine:{formula:"C18H26ClN3",name:"Chloroquine"},
  quinine:{formula:"C20H24N2O2",name:"Quinine"},

  // Neurotransmitters & Hormones
  dopamine:{formula:"C8H11NO2",name:"Dopamine"},
  adrenaline:{formula:"C9H13NO3",name:"Adrenaline"},
  epinephrine:{formula:"C9H13NO3",name:"Epinephrine"},
  serotonin:{formula:"C10H12N2O",name:"Serotonin"},
  melatonin:{formula:"C13H16N2O2",name:"Melatonin"},
  testosterone:{formula:"C19H28O2",name:"Testosterone"},
  estradiol:{formula:"C18H24O2",name:"Estradiol"},
  progesterone:{formula:"C21H30O2",name:"Progesterone"},
  cortisol:{formula:"C21H30O5",name:"Cortisol"},
  insulin:{formula:"C254H377N65O75S6",name:"Insulin (bovine)"},
  thyroxine:{formula:"C15H11I4NO4",name:"Thyroxine"},
  oxytocin:{formula:"C43H66N12O12S2",name:"Oxytocin"},

  // Amino Acids
  glycine:{formula:"C2H5NO2",name:"Glycine"},
  alanine:{formula:"C3H7NO2",name:"Alanine"},
  valine:{formula:"C5H11NO2",name:"Valine"},
  leucine:{formula:"C6H13NO2",name:"Leucine"},
  isoleucine:{formula:"C6H13NO2",name:"Isoleucine"},
  proline:{formula:"C5H9NO2",name:"Proline"},
  serine:{formula:"C3H7NO3",name:"Serine"},
  threonine:{formula:"C4H9NO3",name:"Threonine"},
  cysteine:{formula:"C3H7NO2S",name:"Cysteine"},
  methionine:{formula:"C5H11NO2S",name:"Methionine"},
  phenylalanine:{formula:"C9H11NO2",name:"Phenylalanine"},
  tyrosine:{formula:"C9H11NO3",name:"Tyrosine"},
  tryptophan:{formula:"C11H12N2O2",name:"Tryptophan"},
  histidine:{formula:"C6H9N3O2",name:"Histidine"},
  lysine:{formula:"C6H14N2O2",name:"Lysine"},
  arginine:{formula:"C6H14N4O2",name:"Arginine"},
  aspartate:{formula:"C4H7NO4",name:"Aspartate"},
  glutamate:{formula:"C5H9NO4",name:"Glutamate"},
  asparagine:{formula:"C4H8N2O3",name:"Asparagine"},
  glutamine:{formula:"C5H10N2O3",name:"Glutamine"},

  // Organic Acids
  "acetic acid":{formula:"C2H4O2",name:"Acetic acid"},
  "citric acid":{formula:"C6H8O7",name:"Citric acid"},
  "lactic acid":{formula:"C3H6O3",name:"Lactic acid"},
  "formic acid":{formula:"CH2O2",name:"Formic acid"},
  "oxalic acid":{formula:"C2H2O4",name:"Oxalic acid"},
  "tartaric acid":{formula:"C4H6O6",name:"Tartaric acid"},
  "malic acid":{formula:"C4H6O5",name:"Malic acid"},
  "benzoic acid":{formula:"C7H6O2",name:"Benzoic acid"},
  "stearic acid":{formula:"C18H36O2",name:"Stearic acid"},
  "oleic acid":{formula:"C18H34O2",name:"Oleic acid"},
  "palmitic acid":{formula:"C16H32O2",name:"Palmitic acid"},
  urea:{formula:"CH4N2O",name:"Urea"},

  // Inorganic / Lab Chemicals
  "sodium chloride":{formula:"NaCl",name:"Sodium chloride"},
  "sulfuric acid":{formula:"H2SO4",name:"Sulfuric acid"},
  "hydrochloric acid":{formula:"HCl",name:"Hydrochloric acid"},
  ammonia:{formula:"NH3",name:"Ammonia"},
  "hydrogen peroxide":{formula:"H2O2",name:"Hydrogen peroxide"},
  "sodium hydroxide":{formula:"NaOH",name:"Sodium hydroxide"},
  "potassium chloride":{formula:"KCl",name:"Potassium chloride"},
  "calcium carbonate":{formula:"CaCO3",name:"Calcium carbonate"},
  "sodium bicarbonate":{formula:"NaHCO3",name:"Sodium bicarbonate"},
  "baking soda":{formula:"NaHCO3",name:"Baking soda"},
  "sodium carbonate":{formula:"Na2CO3",name:"Sodium carbonate"},
  "nitric acid":{formula:"HNO3",name:"Nitric acid"},
  "phosphoric acid":{formula:"H3PO4",name:"Phosphoric acid"},
  "calcium chloride":{formula:"CaCl2",name:"Calcium chloride"},
  "magnesium sulfate":{formula:"MgSO4",name:"Magnesium sulfate"},
  "copper sulfate":{formula:"CuSO4",name:"Copper sulfate"},
  "iron oxide":{formula:"Fe2O3",name:"Iron oxide"},
  "carbon dioxide":{formula:"CO2",name:"Carbon dioxide"},
  "carbon monoxide":{formula:"CO",name:"Carbon monoxide"},
  "ozone":{formula:"O3",name:"Ozone"},

  // Vitamins
  "vitamin c":{formula:"C6H8O6",name:"Vitamin C"},
  "ascorbic acid":{formula:"C6H8O6",name:"Ascorbic acid"},
  "vitamin b1":{formula:"C12H17N4OS",name:"Vitamin B1 (Thiamine)"},
  thiamine:{formula:"C12H17N4OS",name:"Thiamine"},
  "vitamin b2":{formula:"C17H20N4O6",name:"Vitamin B2 (Riboflavin)"},
  riboflavin:{formula:"C17H20N4O6",name:"Riboflavin"},
  "vitamin b3":{formula:"C6H5NO2",name:"Vitamin B3 (Niacin)"},
  niacin:{formula:"C6H5NO2",name:"Niacin"},
  "vitamin b12":{formula:"C63H88CoN14O14P",name:"Vitamin B12"},
  "folic acid":{formula:"C19H19N7O6",name:"Folic acid"},
  "vitamin d3":{formula:"C27H44O",name:"Vitamin D3"},
  "vitamin e":{formula:"C29H50O2",name:"Vitamin E"},
  "vitamin k1":{formula:"C31H46O2",name:"Vitamin K1"},

  // Lipids & Steroids
  cholesterol:{formula:"C27H46O",name:"Cholesterol"},
  "atp":{formula:"C10H16N5O13P3",name:"ATP"},
  "adp":{formula:"C10H15N5O10P2",name:"ADP"},
  "nadh":{formula:"C21H29N7O14P2",name:"NADH"},
  "dna":{formula:"C10H14N5O6P",name:"DNA (dAMP unit)"},

  // Shorthand aliases
  nacl:{formula:"NaCl",name:"Sodium chloride"},
  h2so4:{formula:"H2SO4",name:"Sulfuric acid"},
  hcl:{formula:"HCl",name:"Hydrochloric acid"},
  nh3:{formula:"NH3",name:"Ammonia"},
  co2:{formula:"CO2",name:"Carbon dioxide"},
  naoh:{formula:"NaOH",name:"Sodium hydroxide"},
  kcl:{formula:"KCl",name:"Potassium chloride"},
  caco3:{formula:"CaCO3",name:"Calcium carbonate"},
};

const CHIPS = ["ibuprofen","aspirin","paracetamol","caffeine","glucose","sucrose","ethanol","cholesterol","dopamine","serotonin","adrenaline","vitamin c","penicillin","amoxicillin","melatonin"];
const EL_ORDER = ["C","H","N","O","S","P","F","Cl","Br","I"];

function parseFormula(f) {
  function parse(s, pos) {
    const counts = {};
    while (pos < s.length) {
      if (s[pos] === ")") { pos++; break; }
      if (s[pos] === "(") {
        pos++;
        const [sub, newPos] = parse(s, pos);
        pos = newPos;
        let numStr = "";
        while (pos < s.length && s[pos] >= "0" && s[pos] <= "9") { numStr += s[pos]; pos++; }
        const mul = numStr ? parseInt(numStr) : 1;
        for (const [el, ct] of Object.entries(sub)) counts[el] = (counts[el] || 0) + ct * mul;
      } else if (s[pos] >= "A" && s[pos] <= "Z") {
        let sym = s[pos]; pos++;
        while (pos < s.length && s[pos] >= "a" && s[pos] <= "z") { sym += s[pos]; pos++; }
        let numStr = "";
        while (pos < s.length && s[pos] >= "0" && s[pos] <= "9") { numStr += s[pos]; pos++; }
        const ct = numStr ? parseInt(numStr) : 1;
        counts[sym] = (counts[sym] || 0) + ct;
      } else { pos++; }
    }
    return [counts, pos];
  }
  const [counts] = parse(f.trim(), 0);
  return counts;
}

function parseSMILES(smiles) {
  const counts = {};
  const organicSubset = new Set(["B","C","N","O","P","S","F","Cl","Br","I"]);
  let i = 0; const s = smiles.trim();
  while (i < s.length) {
    const ch = s[i];
    if (ch === "[") {
      i++;
      let atom = "";
      while (i < s.length && s[i] !== "]") { atom += s[i]; i++; }
      i++;
      const m = atom.match(/^(\d*)([A-Z][a-z]?)/);
      if (m) { const el = m[2]; counts[el] = (counts[el] || 0) + 1; }
      const hm = atom.match(/H(\d*)/);
      if (hm) { const hc = hm[1] ? parseInt(hm[1]) : 1; counts["H"] = (counts["H"] || 0) + hc; }
    } else if (ch >= "A" && ch <= "Z") {
      let sym = ch; i++;
      if (i < s.length && s[i] >= "a" && s[i] <= "z") { sym += s[i]; i++; }
      if (organicSubset.has(sym)) counts[sym] = (counts[sym] || 0) + 1;
      else { i -= (sym.length - 1); counts[ch] = (counts[ch] || 0) + 1; }
    } else if (ch >= "a" && ch <= "z") {
      let sym = ch.toUpperCase(); i++;
      if (i < s.length && s[i] >= "a" && s[i] <= "z") { sym += s[i]; i++; }
      counts[sym] = (counts[sym] || 0) + 1;
    } else { i++; }
  }
  return counts;
}

function calcMW(counts) {
  const unknown = [];
  let mw = 0;
  for (const [el, ct] of Object.entries(counts)) {
    if (!AW[el]) { unknown.push(el); continue; }
    mw += AW[el] * ct;
  }
  return { mw, unknown };
}

function toSubScript(f) {
  return f.replace(/(\d+)/g, n => n.split("").map(d => "₀₁₂₃₄₅₆₇₈₉"[d]).join(""));
}

function sortedEntries(counts) {
  return Object.entries(counts).sort(([a], [b]) => {
    const ia = EL_ORDER.indexOf(a), ib = EL_ORDER.indexOf(b);
    if (ia > -1 && ib > -1) return ia - ib;
    if (ia > -1) return -1; if (ib > -1) return 1;
    return a.localeCompare(b);
  });
}

export default function App() {
  const [tab, setTab] = useState("formula");
  const [inputs, setInputs] = useState({ formula: "", name: "", smiles: "" });
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  function setInput(key, val) {
    setInputs(p => ({ ...p, [key]: val }));
    setResult(null); setError("");
  }

  function calculate() {
    setResult(null); setError("");
    let counts = {}, label = "";

    if (tab === "formula") {
      const f = inputs.formula.trim();
      if (!f) { setError("Please enter a chemical formula."); return; }
      try { counts = parseFormula(f); } catch { setError("Could not parse formula. Check syntax."); return; }
      label = f;
    } else if (tab === "name") {
      const raw = inputs.name.trim();
      if (!raw) { setError("Please enter a compound name."); return; }
      const match = COMPOUNDS[raw.toLowerCase()];
      if (!match) { setError(`Unknown compound "${raw}". Try: glucose, caffeine, aspirin…`); return; }
      counts = parseFormula(match.formula);
      label = match.name + " — " + match.formula;
    } else {
      const s = inputs.smiles.trim();
      if (!s) { setError("Please enter a SMILES string."); return; }
      counts = parseSMILES(s);
      if (!Object.keys(counts).length) { setError("Could not parse SMILES. Check syntax."); return; }
      label = "SMILES: " + s;
    }

    if (!Object.keys(counts).length) { setError("No elements found in input."); return; }
    const { mw, unknown } = calcMW(counts);
    if (unknown.length) { setError(`Unknown element symbol(s): ${unknown.join(", ")}`); return; }

    const entries = sortedEntries(counts);
    const formulaStr = entries.map(([el, n]) => el + (n > 1 ? n : "")).join("");
    setResult({ mw, entries, formulaStr, label });
  }

  const maxPct = result ? Math.max(...result.entries.map(([el, ct]) => (AW[el] * ct / result.mw) * 100)) : 1;

  return (
    <div className="app">
      <header className="header">
        <div className="header-inner">
          <div className="logo">⚗</div>
          <div>
            <h1>Molecular Weight Calculator</h1>
            <p>Calculate MW and elemental composition by formula, name, or SMILES structure</p>
          </div>
        </div>
      </header>

      <main className="main">
        <div className="card">
          <div className="tabs">
            {["formula","name","smiles"].map(t => (
              <button key={t} className={`tab${tab === t ? " active" : ""}`}
                onClick={() => { setTab(t); setResult(null); setError(""); }}>
                {t === "formula" ? "Formula" : t === "name" ? "Compound Name" : "SMILES"}
              </button>
            ))}
          </div>

          <div className="input-section">
            {tab === "formula" && (
              <>
                <div className="input-row">
                  <input className="chem-input" value={inputs.formula}
                    onChange={e => setInput("formula", e.target.value)}
                    onKeyDown={e => e.key === "Enter" && calculate()}
                    placeholder="e.g. C6H12O6, Ca(OH)2, Al2(SO4)3" />
                  <button className="calc-btn" onClick={calculate}>Calculate</button>
                </div>
                <p className="hint">Examples: <code>H2O</code> · <code>C6H12O6</code> · <code>Ca(OH)2</code> · <code>Al2(SO4)3</code> · <code>C18H36O2</code></p>
              </>
            )}
            {tab === "name" && (
              <>
                <div className="input-row">
                  <input className="chem-input" value={inputs.name}
                    onChange={e => setInput("name", e.target.value)}
                    onKeyDown={e => e.key === "Enter" && calculate()}
                    placeholder="e.g. glucose, caffeine, aspirin" />
                  <button className="calc-btn" onClick={calculate}>Calculate</button>
                </div>
                <div className="chips">
                  {CHIPS.map(n => (
                    <button key={n} className="chip" onClick={() => { setInput("name", n); }}>
                      {n}
                    </button>
                  ))}
                </div>
              </>
            )}
            {tab === "smiles" && (
              <>
                <div className="input-row">
                  <input className="chem-input" value={inputs.smiles}
                    onChange={e => setInput("smiles", e.target.value)}
                    onKeyDown={e => e.key === "Enter" && calculate()}
                    placeholder="e.g. CCO (ethanol), c1ccccc1 (benzene)" />
                  <button className="calc-btn" onClick={calculate}>Calculate</button>
                </div>
                <p className="hint">Examples: <code>CCO</code> · <code>c1ccccc1</code> · <code>CC(=O)Oc1ccccc1C(=O)O</code></p>
              </>
            )}
          </div>

          {error && <div className="error-box">{error}</div>}
        </div>

        {result && (
          <div className="card result-card">
            <p className="result-label">{result.label}</p>
            <div className="metrics">
              <div className="metric">
                <span className="metric-label">Molecular Formula</span>
                <span className="metric-val formula-val">{toSubScript(result.formulaStr)}</span>
              </div>
              <div className="metric">
                <span className="metric-label">Molecular Weight</span>
                <span className="metric-val">{result.mw.toFixed(3)}</span>
                <span className="metric-unit">g/mol</span>
              </div>
              <div className="metric">
                <span className="metric-label">Unique Elements</span>
                <span className="metric-val">{result.entries.length}</span>
              </div>
            </div>

            <h2 className="section-title">Elemental Composition</h2>
            <div className="table-wrap">
              <table className="comp-table">
                <thead>
                  <tr>
                    <th>Element</th>
                    <th>Atoms</th>
                    <th>Atomic Wt (g/mol)</th>
                    <th>Mass Contribution</th>
                    <th>% Composition</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {result.entries.map(([el, ct]) => {
                    const contrib = (AW[el] * ct).toFixed(3);
                    const pct = ((AW[el] * ct / result.mw) * 100).toFixed(2);
                    const barW = Math.round((parseFloat(pct) / maxPct) * 100);
                    return (
                      <tr key={el}>
                        <td><span className="el-badge">{el}</span></td>
                        <td>{ct}</td>
                        <td>{AW[el].toFixed(3)}</td>
                        <td>{contrib}</td>
                        <td>{pct}%</td>
                        <td>
                          <div className="bar-wrap">
                            <div className="bar-fill" style={{ width: barW + "%" }}></div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </main>

      <footer className="footer">
        <p>Molecular Weight Calculator · Atomic weights per IUPAC 2021</p>
      </footer>
    </div>
  );
}
